<section class="page-back">
  <!-- start banner Area -->
  <section class="top-banner">
    <div class="top-banner-img" style="">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 style="padding: 30px 0px 0px 0px !important;"> Informations de : <br>
              <span style="font-size: 22px">{{ consultants.getFirstName() }} {{ consultants.getLastName() }}</span>
            </h1>
            <p class="text-white link-nav"><a [routerLink]="backURL" style="color: #ff5a00 !important">CV thèque
                consultant</a> <span class="lnr lnr-arrow-right"></span>
              <span> Information consultant</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <br> <br>
  <!-- End banner Area -->

  <!-- Start service Area -->
  <section class="service-area section-gap" id="service">
    <div class="container">
      <div class="row">
        <!-- Informations personnelles -->
        <div class="col-md-12 ">
          <div class="card">
            <div class="card-body">
              <fieldset class="form-area fieldset-panel" style="">
                <legend class="legend-style" style="width: 65%;"> Informations personnelles </legend>
                <div>
                  <div class="row">
                    <div class=" col-md-4">
                      <p><span class="titre">Sexe: </span>{{ consultants.getGender() }}</p>
                    </div>
                    <div class=" col-md-4">
                      <p><span class="titre">Date de naissance:
                        </span>{{ consultants.getDateBirth() }}</p>
                    </div>
                    <div class=" col-md-4">
                      <p> <span class="titre">Nom: </span>{{ consultants.getLastName() }}</p>
                    </div>
                    <div class=" col-md-4">
                      <p> <span class="titre">Prénom: </span>{{ consultants.getFirstName() }}</p>
                    </div>

                    <div class=" col-md-4">
                      <p> <span class="titre">Email: </span>{{ consultants.getEmail() }}</p>

                    </div>
                    <div class=" col-md-4">
                      <p> <span class="titre">Honoraire journalier (F CFA): </span>{{ consultants.getDailyFee() }}</p>
                    </div>
                    <div class=" col-md-4">
                      <p> <span class="titre">Téléphone: </span>{{ consultants.getPhone1() }}</p>
                    </div>
                    <div class=" col-md-4">
                      <p> <span class="titre">Téléphone 2: </span>{{ consultants.getPhone2() }}</p>
                    </div>
                  </div>
                  <div class=" my-auto">
                    <button *ngIf="consultants.getCvPath() == null" class="btn btn-info" disabled>Afficher CV</button>
                    <a *ngIf="consultants.getCvPath() != null" [href]="consultants.getCvPath()" target="_blank"
                      class="btn btn-info">Afficher CV</a>
                  </div>
                  <!-- Label block afficher/reduire -->
                  <!-- <div id="infoLabelToShowOrHide"
                class="labelBlock"
                (click)="functionsService.showOrHideBlock('infoBlock', 'infoLabelToShowOrHide')">
                Afficher plus
              </div> -->
                </div>
              </fieldset>
            </div>
          </div>

        </div>

        <!-- Missions -->
        <div class="col-md-6 mt-3">
          <div class="card">
            <div class="card-body">
              <fieldset class="form-area fieldset-panel" style="">
                <legend class="legend-style" style="width: 50%;">Missions conduites</legend>
                <div>
                  <div>
                    <div class="form-group " style="width: 100%; overflow: auto;">
                      <table class="table borderless">
                        <tr>
                          <th>Titre mission</th>
                          <th>Description</th>
                          <th>Certificat</th>
                        </tr>
                        <tr *ngFor="let mission of missionList">
                          <td>{{ mission.getTitle() }}</td>
                          <td title="{{ mission.getDescription() }}">{{
                            functionsService.wordWrap(mission.getDescription(), 50) }}</td>
                          <td><a *ngIf="mission.getCertificatPath() != ''" [href]="mission.getCertificatPath()"
                              target="_blank" class="btn btn-info">Voir</a>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>

        <!-- Produits souhaité -->
        <div class="col-md-6 mt-3">
          <div class="card">
            <div class="card-body">
              <fieldset class="form-area fieldset-panel" style="">
                <legend class="legend-style" style="width: 40%;">Produits</legend>
                <div>
                  <div class="form-group " style="width: 100%; overflow: auto;">
                    <table class="table borderless">
                      <tr>
                        <th>Produits choisis</th>
                      </tr>
                      <tr *ngFor="let produit of produitList">
                        <td>{{ produit.getProduits()['libelle'] }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>

        <!-- Domaine d'expertise -->
        <div class="col-md-6 mb-4 mt-4">
          <div class="card">
            <div class="card-body">
              <fieldset class="form-area fieldset-panel" style="">
                <legend class="legend-style" style="width: 45%;">Expertises</legend>
                <div>
                  <div class="form-group" style="width: 100%; overflow: auto;">
                    <table class="table borderless">
                      <tr>
                        <th>Expertises choisies</th>
                      </tr>
                      <tr *ngFor="let expertise of expertiseList">
                        <td>{{ expertise.getExpertises()['libelle'] }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>

        </div>

        <!-- Countries -->
        <div class="col-md-6 mt-4 mb-4">
          <div class="card">
            <div class="card-body">
              <fieldset class="form-area fieldset-panel">
                <legend class="legend-style" style="width: 35%;">Pays</legend>
                <div>
                  <div class="form-group " style="width: 100%; overflow: auto;">
                    <table class="table borderless">
                      <tr>
                        <th>Pays souhaités</th>
                      </tr>
                      <tr *ngFor="let country of countryList">
                        <td>{{ country.getCountry() }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>

        </div>

      </div>
    </div>
  </section>
  <!-- End service Area -->

</section>